export default __webpack_public_path__ + "a6454ad24edee0db5a3f4a62dc934d3b.png";